import React from "react";
import { capitalize, pluralizeWithCount } from "@common/helpers/string";
import { StatusFilter, StatusFilterType } from "@common/types/statusFilter";
import { FilterLabel } from "./FilterLabel";

interface Props {
    statusFilter: StatusFilter<string> | undefined;
}

const filterTypeToPrefix: Record<StatusFilterType, string> = {
    [StatusFilterType.ALL_SELECTED]: "Every: ",
    [StatusFilterType.ANY_SELECTED]: "Any: ",
    [StatusFilterType.EXCLUDE_SELECTED]: "Exclude: ",
};

export const CombinedStatusFilterLabel: React.FC<Props> = ({
    statusFilter,
}) => {
    const statuses = statusFilter
        ? [...statusFilter.kickStatuses, ...statusFilter.externalStatuses]
        : [];

    if (!statusFilter || statuses.length === 0) {
        return <FilterLabel label={undefined} />;
    }

    const selection =
        statuses.length === 1
            ? capitalize(statuses[0])
            : pluralizeWithCount("status", statuses.length);

    return (
        <FilterLabel
            label={`${filterTypeToPrefix[statusFilter.filterType]}${selection}`}
        />
    );
};
